<div class="confirmation-code-report">
    <bc-paginated-table [columnHeadings]="columnHeadings" [pagination]="pagination" [getRows]="getRows"
        [getDisplay]="getDisplay" [defaultFilterCondition]="FilterCondition.LIKE" [columnWidths]="tableColumnWidths">
    </bc-paginated-table>
</div>